import React from "react";
import Header from "../../../commons/Header/Header";
import Footer from "../../../commons/Footer/Footer";
import "./PrivacyPolicy.css";

const PrivacyPolicy = (props) => {
  return (
    <>
    <Header en="/privacy-policy" fr="/politique-de-confidentialite" lang="en" />
    <div className="container mainDiv ab">
      <div className="row">
        <div className="col-xs-12 content">
          <h1 className="privacy-policy">Privacy Policy</h1>
          <div>
            <ol className="tlprivacypolicy">
              <li>
                <h2>Introduction</h2>
                <p>Travelance Inc ("we", "us", "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy outlines how we collect, use, disclose, and safeguard your data in accordance with Canadian privacy laws (PIPEDA and CPPA) and the EU General Data Protection Regulation (GDPR), where applicable.</p>
                <p>By using <a class="c3" href="https://www.travelance.ca">travelance.ca</a>, Quote portal (quote.travelance.ca), MyTL web portal (mytl.travelance.ca), or any other services provided by Travelance Inc., you consent to the practices described in this Privacy Policy.</p>
              </li>
              <li>
                <h2>Information We Collect</h2>
                <p>We collect the following types of personal and non-personal information:</p>
                <ul>
                    <li>Personal Information: Full name, contact details (email, phone, address), payment information, travel details, medical questions, IP address.</li>
                    <li>Technical Information: Browser type, device identifiers, cookies, access times, and referring URLs.</li>
                    <li>Usage Data: Pages visited, links clicked, time spent on site.</li>
                </ul>
              </li>
              <li>
                <h2>How We Use Your Information</h2>
                <p>We use your data to:</p>
                <ul>
                    <li>Process insurance quotes and applications</li>
                    <li>Provide customer support</li>
                    <li>Customize your experience on our website</li>
                    <li>Prevent fraud and ensure security</li>
                    <li>Comply with legal and regulatory obligations</li>
                    <li>Send marketing communications (only with your explicit consent)</li>
                </ul>
              </li>
              <li>
                <h2>Legal Basis for Processing (GDPR)</h2>
                <p>We process your personal data on one or more of the following legal bases:</p>
                <ul>
                    <li>Your consent</li>
                    <li>To fulfill a contractual obligation</li>
                    <li>For our legitimate interests, provided they do not override your rights</li>
                    <li>Compliance with a legal obligation</li>
                </ul>
              </li>
              <li>
                <h2>Data Sharing and Third Parties</h2>
                <p>We may share your information with:</p>
                <ul>
                    <li>Affiliates and subsidiaries under common ownership</li>
                    <li>Third-party service providers for payment processing, email delivery, analytics, and hosting</li>
                    <li>Legal authorities when required by law or to protect our legal interests</li>
                    <li>Business partners if we undergo a merger, acquisition, or asset sale (with user notice)</li>
                </ul>
                <p>Each third party is contractually bound to only use your data as instructed by Travelance Inc.</p>
              </li>
              <li>
                <h2>International Data Transfers</h2>
                <p>If data is transferred outside of Canada , we ensure it is protected by Standard Contractual Clauses (SCCs) or equivalent safeguards.</p>
              </li>
              <li>
                <h2>Data Retention</h2>
                <p>We retain personal information only as long as necessary for the purposes stated or as required by law. When no longer needed, your data will be securely deleted or anonymized.</p>
              </li>
              <li>
                <h2>Your Rights</h2>
                <p>You have the right to:</p>
                <ul class="c13 lst-kix_p1c5qpgikcyu-0 start">
                    <li>Access the personal data we hold about you</li>
                    <li>Correct inaccurate or outdated data</li>
                    <li>Request deletion of your data (subject to legal obligations)</li>
                    <li>Object to or restrict processing in certain situations</li>
                    <li>Withdraw consent at any time (for data processed based on consent)</li>
                    <li>Request data portability in a machine-readable format</li>
                </ul>
                <p>To exercise any of these rights, email us at: <a href="mailto:admin@travelance.ca">admin@travelance.ca</a>.</p>
              </li>
              <li>
                <h2>Cookies and Tracking</h2>
                <p>Travelance Inc. uses cookies and similar technologies to power core features (e.g., live chat) and to analyze site traffic (via Google Analytics, Microsoft Clarity, ClickCease, etc.). By continuing to use our website, you consent to the placement of these cookies.</p>
                <p>For more details about our use of cookies and how to manage them, please refer to the Cookies section in our <a href="/terms-conditions">Terms and Conditions</a>.</p>
              </li>
              <li>
                <h2>Data Security</h2>
                <p>We employ industry-standard technical and organizational measures, including encryption, firewalls, secure access controls, and intrusion detection systems, to protect your information.</p>
              </li>
              <li>
                <h2>Data Breach Notification</h2>
                <p>In the event of a data breach, we will notify affected users and regulators within the legally required timeframe, as per CPPA or GDPR regulations.</p>
              </li>
              <li>
                <h2>Children&rsquo;s Privacy</h2>
                <p>Travelance Inc. does not knowingly collect data from children under 13. If we learn that we have collected such data without parental consent, we will delete it promptly.</p>
              </li>
              <li>
                <h2>Applies To</h2>
                <p>This Privacy Policy applies to all individuals whose personal information is collected, processed, or stored by Travelance Inc., including users of our website and related services.</p>
              </li>
              <li>
                <h2>Changes to This Policy</h2>
                <p>We may update this Privacy Policy periodically. When we do, we will revise the "Effective Date" shown at the bottom of this document and provide notice via our website. Continued use of our services implies consent to the updated terms.</p>
              </li>
              <li>
                <h2>Contact Us</h2>
                <p>If you have any questions regarding this privacy Policy, please contact us using this form: <a href="https://www.travelance.ca/contact-us">www.travelance.ca/contact/</a> or by email to <a href="mailto:admin@travelance.ca">admin@travelance.ca</a></p>
              </li>
            </ol>
            <p><b>Effective Date</b>: July 02, 2013</p>
            <p><b>Last Updated</b>: June 04, 2025</p>
          </div>
        </div>
      </div>
    </div>
    <Footer lang="en" />
    </>
  );
}

export default PrivacyPolicy;
